export default function ($translate) {
    return {
        KEYS: {
            USER_SPECIFIC: 'USER_SPECIFIC',
            SYSTEM: 'SYSTEM',
            PERSONNEL_SOFTWARE: 'PERSONNEL_SOFTWARE'
        },
        LABELS: {
            USER_SPECIFIC: $translate.instant('auditlog.type.User Specific'),
            SYSTEM: $translate.instant('auditlog.type.System'),
            PERSONNEL_SOFTWARE: $translate.instant('auditlog.type.Personnel software')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/auditlog/type/index.js